import React from 'react'
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
const DeleteDialog = (
    {
        popUpVisible,
        setPopUpVisible,
        handleCancel,
        headercomponent
    }
) => {

  const deltePhotohandle = () => {
    setPopUpVisible(false);
  }
  return (
    <div className="align-items-center justify-content-center p-2">
            <Dialog
              header={headercomponent}
              visible={popUpVisible}
              draggable={false}
              modal={true}
              style={{ width: "50vw" }}
              className="custom-dialog"
              onHide={() => setPopUpVisible(false)}
            >
              <div className="border-1 border-round-xs border-300 p-4">
                <div>Are you sure you want to delete your profile photo?</div>
                <div className="font-semibold mt-1 border-300 text-800">
                  This action cannot be reversed, and your current photo will be
                  removed from your profile.
                </div>
                <div className="flex justify-content-center gap-3 mt-4">
                  <Button
                    label="Cancel"
                    className="w-6rem h-2rem bg-white border-500 text-500"
                    onClick={handleCancel}
                  />
                  <Button label="Delete" className="w-10rem h-2rem dltbtn" onClick={deltePhotohandle}/>
                </div>
              </div>
            </Dialog>
          </div>
  )
}

export default DeleteDialog;
